module.exports = __webpack_public_path__ + "img/bankboston.ec3f522e.svg";